var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "a-form-model",
        {
          staticClass: "user-layout-login",
          nativeOn: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleSubmit($event)
            }
          }
        },
        [
          _c(
            "a-row",
            {
              staticStyle: { "padding-bottom": "25px" },
              attrs: { gutter: 24 }
            },
            [
              _c("a-col", { staticClass: "gutter-row", attrs: { span: 6 } }),
              _c("a-col", { staticClass: "gutter-row", attrs: { span: 18 } })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loginType == "login",
                  expression: "loginType=='login'"
                }
              ]
            },
            [
              _c("div", { staticClass: "aui-formBox" }, [
                _c("div", { staticClass: "aui-formWell" }, [
                  _c(
                    "div",
                    { staticClass: "aui-flex aui-form-nav investment_title" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "aui-flex-box",
                          class:
                            _vm.activeIndex === "accountLogin"
                              ? "activeNav on"
                              : "",
                          on: {
                            click: function($event) {
                              return _vm.loginClick("accountLogin")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.language["portal.ui2.accountLogin"]) +
                              "\n            "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "aui-flex-box",
                          class:
                            _vm.activeIndex === "civetLogin"
                              ? "activeNav on"
                              : "",
                          on: { click: _vm.handleLoginWithIcivet }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.language["portal.ui2.xiangxinAuth"]) +
                              "\n            "
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _c("login-account", {
                ref: "alogin",
                on: {
                  validateFail: _vm.validateFail,
                  success: _vm.requestSuccess,
                  fail: _vm.requestFailed
                }
              }),
              _c(
                "a-form-model-item",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "forge-password",
                      staticStyle: { float: "right" },
                      attrs: {
                        to: { name: "alteration", query: { type: "password" } }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.language["sys.forget.password"])
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                [
                  _c("j-language-menu", {
                    ref: "languageMenu",
                    attrs: { size: "default" }
                  })
                ],
                1
              ),
              _c(
                "a-form-item",
                { staticStyle: { "margin-top": "15px", bottom: "10px" } },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "login-button",
                      attrs: {
                        size: "large",
                        type: "primary",
                        htmlType: "submit",
                        disabled: _vm.loginBtn
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.handleSubmit($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.language["system.loginButton"]) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("user-password", { ref: "userPassword" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }